import React, { useEffect, useState } from 'react'
import { useStateContext } from '../context/StateContext'
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext'
import { AuthContext } from '../context/AuthContext'
import BlueButton from './BlueButton'
import { ShortText, StepByStepProgress } from './Survey'
import T from './Translation'
import TextField from '../whitaijiFrontendLibrary/components/TextField'
import { generateMongoDBId } from '../whitaijiFrontendLibrary/lib/utils'
import { blueColour, goldColour, lighterBlueColour, Tag } from '../pages/Home'
import AiGeneratedConcert from './MakeConcert/AiGeneratedConcert'
import ChooseSongs from './MakeConcert/ChooseSongs'
import ChooseLyrics from './MakeConcert/ChooseLyrics'
import AddQuotes from './MakeConcert/AddQuotes'
import SongsOrder from './MakeConcert/SongsOrder'
import { useNavigate } from 'react-router-dom'
//import { songsData } from '../data/songsData'
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query'
import { _CREATE, _UPDATE, _FETCH } from '../utils/patches';
import { errorAlert, successAlert } from '../utils/utils'
import { IoNavigateCircleOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import Loading from '../whitaijiFrontendLibrary/components/Loading'
import ScrollDiv from './ScrollDiv'
import TextHighlight from './TextHighlight'
import { GoldTags } from '../pages/Home'
import { rumiQuotes } from '../whitaijiFrontendLibrary/components/Loading'
import Swal from 'sweetalert2'
import { dT } from './Translation'
import { UserIcon } from './ProfileMenu'
import { ConcertLogReport } from '../pages/JournalEntry'
import { IoIosJournal } from "react-icons/io";
import Concert from '../pages/Concert'
import ConcertMusicPlayer from './ConcertMusicPlayer'



const MakeConcert = () => {

      const emptyConcertDoc = () => ({
        _id: generateMongoDBId(),
        user_id: user._id,
        assignedToUserId: undefined,
        assignedToAllMindproUsers: false,
        title: "",
        description: "",
        aiAnswer:"",
        aiQuestion:"",
        songs: [],
        nSongs: 1
      })

      const navigate = useNavigate();
      const {hideTestButtons, language, concert, setConcert, apiUrl, myMindPro, setMyMindPro} = useStateContext()
      const [validationErrors, setValidationErrors] = useState({});
      const [loading, setLoading] = useState(false);
      const {user} = useAuthContext(AuthContext)
      const queryClient = useQueryClient()

      //_FETCH users
            const { data: mindproUsersProfileData, error: mindproUserDataError, isLoading: mindproUserProfileDataLoading } = useQuery({
              queryKey: ['myMindProData'],
              enabled: !!user && user.userType === "mindPro", // Only fetch if user is logged in
              queryFn: async () => {
                  const userData = await _FETCH({
                    route: `${apiUrl}/user/get-mindpro-users/${user._id}`,
                    user,
                  });
      
                  return userData;
                }
          });
          // fetch my mindpro
            const { data: myMindProData, error: myMindProDataError, isLoading: myMindProDataLoading } = useQuery({
              queryKey: ['mindproUserProfileData'],
              enabled: !!user && user.userType === "user", // Only fetch if user is logged in
              refetchOnWindowFocus: false,
              queryFn: async () => {
                  const userData = await _FETCH({
                    route: `${apiUrl}/user/get-my-mindpro/${user._id}`,
                    user,
                    onSuccess: (data) => {
                      //setMyMindPro(data)
                      //process.env.NODE_ENV === "development" && console.log(" clc wljcfe")
                    }
                  });
      
                  return userData;
                }
          });
      const createConcert = () => setConcert(emptyConcertDoc())
      const resetConcert = () => {
        Swal.fire({
          title: dT({en: 'Did You Save?', it: 'Hai salvato?'}, language),
          text: dT({en: 'Any unsaved changes will be lost', it: 'Qualsiasi cambiamento non salvato verrà perso'}, language),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: blueColour,
          cancelButtonColor: goldColour,
          confirmButtonText: dT({en: 'I want to Exit', it: 'Voglio Uscire'}, language),
          cancelButtonText: dT({en: 'Cancel', it: 'Annulla'}, language)
        }).then((result) => {
          if (result.isConfirmed) {
            setConcert(emptyConcertDoc())
          }
        })
       } 
      const deleteConcert = () => {
        Swal.fire({
          title: dT({en: 'Did You Save?', it: 'Hai salvato?'}, language),
          text: dT({en: 'Any unsaved changes will be lost', it: 'Qualsiasi cambiamento non salvato verrà perso'}, language),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: blueColour,
          cancelButtonColor: goldColour,
          confirmButtonText: dT({en: 'I want to Exit', it: 'Voglio Uscire'}, language),
          cancelButtonText: dT({en: 'Cancel', it: 'Annulla'}, language)
        }).then((result) => {
          if (result.isConfirmed) {
            setConcert(undefined)
            setTimeout(() => {
              window.location.reload();
            }, 50)
      
          }
        })
        }

        const [error, setError] = useState(null);
      
      const onError = (e) => {
        setError(e.error);
        errorAlert(e.error || 'Failed to save concert');
      
      }
    
      const onSuccess = (json, concertExists) => {
        if (json.error) {
          setError(json.error);
          errorAlert(json.error);
          return;
        }
        setError(null);
        const message = concertExists ? 'Concert edited successfully!' : 'Concert saved successfully!';
        successAlert(message);
      }
            const { data: songsData, isLoading: isLoadingSongs } = useQuery({
              queryKey: ['songsDataConcert'],
              queryFn: async () => {
                try {
                  const response = await _FETCH({
                    route: `${apiUrl}/songs`,
                    user,
                  });
                  //const data = await response.json();
                  //process.env.NODE_ENV === "development" && console.log("songs loaded", data)
                  return response;
                } catch (error) {
                  process.env.NODE_ENV === "development" && console.error('Error fetching songs:', error);
                  return [];
                }
              },
              enabled: !!user,  // Only fetch if user is logged in
              refetchOnWindowFocus: false,
            });
/*             const { data: albumSongsData, isLoading: isLoadingAlbumSongs } = useQuery({
              queryKey: ['albumSongsDataConcert'],
              queryFn: async () => {
                try {
                  const response = await fetch(`${apiUrl}/songs/with-prelude`, {
                    headers: {
                      'Authorization': `Bearer ${user.token}`
                    }
                  });
                  const data = await response.json();
                  //process.env.NODE_ENV === "development" && console.log("songs loaded", data)
                  return data;
                } catch (error) {
                  process.env.NODE_ENV === "development" && console.error('Error fetching songs:', error);
                  return [];
                }
              },
              enabled: !!user // Only fetch if user is logged in
            }); */

      // These are the users that I have assigned to

      const { data: userConcerts, isLoading: isLoadingUserConcerts } = useQuery({
        queryKey: ['userConcertsData'],
        queryFn: async () => {
          try {
            const response = await _FETCH({
              route: `${apiUrl}/concerts/all-my-users`, 
              user
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("concerts loaded", data)
            return response;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching userConcerts:', error);
            return [];
          }
        },
        enabled: !!user && user?.userType === "mindPro", // Only fetch if user is logged in
        refetchOnWindowFocus: false,
      });

      const { data: allMyUsersPublicConcerts, isLoading: isLoadingAllMyUsersPublicConcerts } = useQuery({
        queryKey: ['allUsersPublicConcertsData'],
        queryFn: async () => {
          try {
            const response = await _FETCH({ 
              route: `${apiUrl}/concerts/public/all-my-users`, 
              user 
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("concerts loaded", data)
            return response;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching concerts:', error);
            return [];
          }
        },
        enabled: !!user && user?.userType === "mindPro", // Only fetch if user is logged in
        refetchOnWindowFocus: false,
      });

      const { data: myConcerts, isLoading: isLoadingMyConcerts } = useQuery({
        queryKey: ['myConcertsData'],
        queryFn: async () => {
          try {
            const response = await _FETCH({ 
              route: `${apiUrl}/concerts/my-concerts`, 
              user
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("concerts loaded", data)
            return response;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching concerts:', error);
            return [];
          }
        },
        enabled: !!user, // Only fetch if user is logged in
        refetchOnWindowFocus: false,
      });
      const { data: publicConcerts, isLoading: isLoadingPublicConcerts } = useQuery({
        queryKey: ['publicConcertsData'],
        queryFn: async () => {
          try {
            const response = await _FETCH({ 
              route:`${apiUrl}/concerts/public/michael`,
              user, 
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("concerts loaded", data)
            return response;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching concerts:', error);
            return [];
          }
        },
        enabled: !!user, // Only fetch if user is logged in
        refetchOnWindowFocus: false,
      });
      const { data: mindProConcerts, isLoading: isLoadingMindProConcertsConcerts } = useQuery({
        queryKey: ['mindProConcertsData'],
        queryFn: async () => {
          try {
            const response = await _FETCH({
              route:`${apiUrl}/concerts//public/my-mindpro/${myMindProData?._id}`,
              user
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("concerts loaded", data)
            return response;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching concerts:', error);
            return [];
          }
        },
        enabled: !!user && !!myMindProData, // Only fetch if user is logged in
        refetchOnWindowFocus: false,
      });
      const { data: assignedToMeConcerts, isLoading: isLoadingAssignedToMeConcerts } = useQuery({
        queryKey: ['assignedToMeConcertsData'],
        queryFn: async () => {
          try {
            const response = await _FETCH({
              route:`${apiUrl}/concerts/assigned-to-me`, 
              user,
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("concerts loaded", data)
            return response;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching concerts:', error);
            return [];
          }
        },
        enabled: !!user, // Only fetch if user is logged in
        refetchOnWindowFocus: false,
      });
      const { data: concertLogs, isLoading: isLoadingConcertLogs } = useQuery({
        queryKey: ['concertLogsData'],
        queryFn: async () => {
          try {
            const response = await _FETCH({
              route:`${apiUrl}/concert-logs/`, 
              user,
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("concerts loaded", data)
            return response;
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching concerts:', error);
            return [];
          }
        },
        enabled: !!user, // Only fetch if user is logged in
        refetchOnWindowFocus: false,
      });
    const addQueryKey = (concertArray, queryKey) => {
      return concertArray?.map(concert => ({...concert, queryKey: queryKey}))
    }
    const allConcerts = [
      ...!Array.isArray(publicConcerts) ? [] : addQueryKey(publicConcerts, ["publicConcerts"]), 
      ...!Array.isArray(assignedToMeConcerts) ? [] : addQueryKey(assignedToMeConcerts, ["assignedToMeConcerts"]), //assignedToMeConcerts, 
      ...!Array.isArray(allMyUsersPublicConcerts) ? [] : addQueryKey(allMyUsersPublicConcerts, ['allUsersPublicConcertsData']), //allMyUsersPublicConcerts, 
      ...!Array.isArray(myConcerts) ? [] : addQueryKey(myConcerts, ['myConcertsData']),
      ...!Array.isArray(mindProConcerts) ? [] : addQueryKey(mindProConcerts, ['mindProConcertsData']), //mindProConcerts,
      ...!Array.isArray(userConcerts) ? [] : addQueryKey(userConcerts, ['userConcertsData']), //userConcerts,
    ]

    const concertsInProgress = !Array.isArray(concertLogs) ? [] :  concertLogs?.filter(x => x?.status === "inProgress")?.map(item => {

      const findConcert = ! Array.isArray(allConcerts) ? undefined : allConcerts?.find(x => x?._id === item?.concertId);
      //console.log( "kjsnckjsnc", {findConcert, item, allConcerts})
      if(findConcert) {
        return findConcert
      }
    });
    const concertsCompleted = !Array.isArray(concertLogs) ? [] :  concertLogs?.filter(x => x?.status === "completed")

    const scrollItemStyle = {
                  display: "flex", 
                  width: "370px",
                  minWidth: "370px",
                  padding: "15px", 
                  borderRadius: "10px", 
                  border: "1px solid #ccc", 
                  margin: "10px",
                  flexDirection: "column",
                  background: "white",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }
    const concertInAllConcerts = allConcerts?.find(x => x?._id === concert?._id);
    const queryKey = concertInAllConcerts?.queryKey

    const { mutate: addConcert, isLoading } = useMutation({
        mutationFn: async(concert) => {

          try {
            
            if (concert?._id) {
              // Check if concert exists in user's concerts
              const concertExists = allConcerts?.some(x => x?._id === concert?._id);
               process.env.NODE_ENV === "development" && console.log("oweijdwoi updating concert", {concertExists, queryKey})
              //process.env.NODE_ENV === "development" && console.log("concertExists", concertExists)
              if (concertExists) {
                // Update existing concert
                process.env.NODE_ENV === "development" && console.log("oweijdwoi updating concert", concert?._id)
                const response = await _UPDATE({
                  doc: concert, 
                  user, 
                  route: `${apiUrl}/concerts/${concert._id}`, 
                  onError
                });
                onSuccess(response, concertExists);
                return response;
              } else {
                // Create new concert if it doesn't exist
                return await _CREATE({
                  doc: { ...concert, _id: undefined }, // Remove _id for new creation
                  user, 
                  route: `${apiUrl}/concerts`, 
                  onError, 
                  onSuccess
                });
              }
            } else {
              // Create new concert
              return await _CREATE({
                doc: concert, 
                user, 
                route: `${apiUrl}/concerts`, 
                onError, 
                onSuccess
              });
            }
          } catch (error) {
            onError(error);
            throw error;
          }
        },
        onSettled: () => queryClient.invalidateQueries({ queryKey: queryKey }),
        mutationKey: queryKey,
      });
    
      const generateElevenLabsVo = async (song) => {
        try {
          const fileName = song?._id 
          if(!fileName) {
            throw new Error('No song ID provided');
          }
          const textToSpeech = song?.affirmation;

          if (!textToSpeech) {
            throw new Error('No affirmation text provided');
          }

          // Validate text length
          if (textToSpeech.length > 230) {
            throw new Error('Affirmation text is too long (maximum 230 characters)');
          }

          // Basic text sanitization
          const sanitizedText = textToSpeech
            .trim()
            .replace(/[\u0000-\u001F\u007F-\u009F]/g, '') // Remove control characters
            .replace(/\s+/g, ' '); // Normalize whitespace

          if (!sanitizedText) {
            throw new Error('Affirmation text contains no valid characters');
          }

          process.env.NODE_ENV === "development" && console.log('Generating audio for text:', sanitizedText);

          // Generate audio from ElevenLabs
          const response = await fetch(`${apiUrl}/elevenlabs/text-to-speech`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${user.token}`
            },
            body: JSON.stringify({ text: sanitizedText })
          });

          process.env.NODE_ENV === "development" && console.log('ElevenLabs response status:', response.status);

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to generate audio');
          }

          // Verify content type
          const contentType = response.headers.get('content-type');
          if (!contentType || !contentType.includes('audio/mpeg')) {
            throw new Error('Invalid audio format received');
          }

          // Get audio blob from response
          const audioBlob = new Blob([await response.arrayBuffer()], { type: 'audio/mpeg' });

          // Create form data for S3 upload
          const formData = new FormData();
          formData.append('file', audioBlob, `${fileName}.mp3`);

          // Upload to S3
          const s3Response = await fetch(`${apiUrl}/s3/upload-aivo`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${user.token}`
            },
            body: formData
          });

          if (!s3Response.ok) {
            const error = await s3Response.json();
            throw new Error(error.error || 'Failed to upload audio to S3');
          }

          process.env.NODE_ENV === "development" && console.log('Successfully generated and uploaded audio for:', fileName);
        } catch (error) {
          process.env.NODE_ENV === "development" && console.error('Error in generateElevenLabsVo:', error);
          errorAlert(error.message);
        }
      }
    const saveConcert = async () => {
        setLoading(true);
        try {
            const concertSongs = !Array.isArray(concert?.songs) ? [] : concert?.songs
            const isThereIds = !Array.isArray(concertSongs) ? [] : concertSongs?.every((x)=>x?._id)
            
        if (!isThereIds) {
          const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

          const addIdsAndAiVo = await Promise.all(concertSongs?.map(async (song, index) => {
          
          const songId = song?._id ? song?._id : generateMongoDBId();
          const songWithId = {...song, _id: songId}
            
            if(song?.affirmation) {
              // Add delay between requests to avoid hitting concurrent request limit
              await delay(index * 3000); // 3 second delay between each request
              
              // Retry logic for concurrent request errors
              let retries = 3;
              while (retries > 0) {
                try {
                  await generateElevenLabsVo(songWithId);
                  break; // Success, exit retry loop
                } catch (error) {
                  if (error.message.includes('Too many concurrent requests') && retries > 1) {
                    process.env.NODE_ENV === "development" && console.log(`Retrying after error: ${error.message}. Retries left: ${retries - 1}`);
                    await delay(2000); // Wait 2 seconds before retry
                    retries--;
                  } else {
                    throw error; // Rethrow if not a concurrent request error or no retries left
                  }
                }
              }
            }
            return songWithId;
          }
        
        ));
          const newConcert = {
            ...concert,
            songs: addIdsAndAiVo
          }
          process.env.NODE_ENV === "development" && console.log("save with new ids concert", {newConcert, isThereIds});
          // Only save after all audio files are generated
          addConcert(newConcert);
        }
        else {
          process.env.NODE_ENV === "development" && console.log("save concert", {concert, isThereIds})
          await addConcert(concert)
        }
        setLoading(false);
    } catch (error) {
        setLoading(false);
        process.env.NODE_ENV === "development" && console.error('Error in saveConcert:', error);
        errorAlert(error.message || 'Failed to save concert');
    }
}
/*       useEffect(() => {
        // Only initialize if concert is explicitly undefined/null (not during initial load)
        if (concert === undefined || concert === null) {
          setConcert(emptyDoc())
        }
      }, []) // Run only once on mount */
      const songsDataWithPrelude =  !Array.isArray(songsData) ? [] : songsData?.filter((x)=>x?.isWithPrelude)
      const songsDataWithoutPrelude =  !Array.isArray(songsData) ? [] : songsData?.filter((x)=>!x?.isWithPrelude)
      const commonData = {
        concert,
        setConcert,
        songsData: songsDataWithPrelude,
        hideTestButtons,
      }
      const progressList = [
          {tabTitle:  <T obj={{en: "Generate Concert", it: "Genera Concerto"}} />, component: <AiGeneratedConcert data={{...commonData, mindproUsers: mindproUsersProfileData, emptyDoc: emptyConcertDoc()}}/>},
          {tabTitle:  <T obj={{en: "Choose Songs", it: "Scegli le Canzoni"}} />, component: <ChooseSongs data={{...commonData}}/>},
          {tabTitle:  <T obj={{en: "Choose Lyrics", it: "Scegli I Testi"}} />, component: <ChooseLyrics data={{...commonData}}/>},
          {tabTitle:  <T obj={{en: "Add Quotes", it: "Aggiungi Citazioni"}} />, component: <AddQuotes data={{...commonData, generateElevenLabsVo}}/>},
          {tabTitle:  <T obj={{en: "Song Order", it: "Scaletta"}} />, component: <SongsOrder data={{...commonData}}/>},
      ]
      const testFunction = () => {
        process.env.NODE_ENV === "development" && console.log("testFunction",
          {
              //concert,
                 //myConcerts,
              //userConcerts,
              //publicConcerts,
              //mindProConcerts,
              //assignedToMeConcerts,
              //allMyUsersPublicConcerts,
              //myConcerts,
              //allConcerts,
              concert,
              concertLogs,
              concertsInProgress,
              concertsCompleted,
              //myMindProData,
              //user,
              //mindproUsers: mindproUsersProfileData, //mindproUsersProfileData,
              //generateId: generateMongoDBId(),
              //songsDataString:  `songsData:\n${JSON.stringify(songsDataWithPrelude, null, 2)}`,
              //songsDataWithPrelude,
              //songsDataWithoutPrelude
          }
        )
    }
     
    if(
      isLoadingUserConcerts || 
      isLoadingSongs || 
      loading || 
      myMindProDataLoading || 
      mindproUserProfileDataLoading||
      isLoadingAllMyUsersPublicConcerts || 
      isLoadingPublicConcerts || 
      isLoadingMyConcerts ||
      isLoadingAllMyUsersPublicConcerts || 
      isLoadingAssignedToMeConcerts ||
      isLoadingMindProConcertsConcerts ||
      isLoadingConcertLogs
    
    ) return  <Loading/> 

    if(!concert) {
        return (
          <div style={{display: "flex", flexDirection: "column"}}>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
              <BlueButton color={"green"}hide={user?.userType === "user"} text={<T obj={{en: "Create Concert", it: "Crea Concerto"}} />} fn={createConcert}/>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
              <BlueButton color={"green"}hide={hideTestButtons} text={<T obj={{en: "Test Users", it: "Test Users"}} />} fn={testFunction}/>
            </div>
            <VisDiv rules ={[Array.isArray(concertsInProgress), concertsInProgress?.length > 0]}>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                <h3><T obj={{en: `Concerts in progress`, it: `Concerti in corso`}} /></h3>
              </div>
              <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
                {!Array.isArray(concertsInProgress) ? [] : concertsInProgress?.map((pinConcert, index) => 
                  <ConcertPin 
                    key={index} 
                    data={{
                      songsData: songsDataWithPrelude?.filter((x)=> pinConcert?.songs?.some((y)=> y?.songTemplateId === x?._id && y?.status !== "archived")), 
                      concert: pinConcert, 
                      myMindPro: myMindProData, 
                      mindproUsers: mindproUsersProfileData, //mindproUsersProfileData
                      user,
                      setConcert
                    }} 
                  />)}
              </ScrollDiv>
            </VisDiv>
            <VisDiv rules ={[user?.userType == "mindPro"]}>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                <h3><T obj={{en: "Concerts Assigned To My Clients", it: "Concerti Assegnati Ai Miei Clienti"}} /></h3>
              </div>
              {(!Array.isArray(userConcerts) || userConcerts?.length < 1) ? 
                <div className="scroll-item" style={scrollItemStyle}>
                  <p><T obj={{en: "You haven't created any concerts yet", it: "Non hai ancora creato nessun concerto"}} /></p>
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start"}}>
                    <BlueButton color={"green"}hide={user?.userType === "user"} text={<T obj={{en: "Create Concert", it: "Crea Concerto"}} />} fn={createConcert}/>
                  </div>
                  </div> 
                : null}
              <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
                {!Array.isArray(userConcerts) ? [] : userConcerts?.map((pinConcert, index) => 
                  <ConcertPin 
                    key={index} 
                    data={{
                      songsData: songsDataWithPrelude?.filter((x)=> pinConcert?.songs?.some((y)=> y?.songTemplateId === x?._id && y?.status !== "archived")), 
                      concert: pinConcert, 
                      myMindPro: myMindProData,
                      mindproUsers: mindproUsersProfileData, //mindproUsersProfileData 
                      user,
                      setConcert
                    }} 
                  />)}
              </ScrollDiv>
            </VisDiv>
            <VisDiv rules ={[user?.userType == "mindPro"]}>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                <h3><T obj={{en: "My Public Concerts (To My Clients)", it: "I Miei Concerti Pubblici (Per I Miei Clienti)"}} /></h3>
              </div>
              {(!Array.isArray(allMyUsersPublicConcerts) || allMyUsersPublicConcerts?.length < 1) ? 
                <div className="scroll-item" style={scrollItemStyle}>
                  <p><T obj={{en: "You haven't created any concerts yet", it: "Non hai ancora creato nessun concerto"}} /></p>
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start"}}>
                    <BlueButton color={"green"}hide={user?.userType === "user"} text={<T obj={{en: "Create Concert", it: "Crea Concerto"}} />} fn={createConcert}/>
                  </div>
                  </div> 
                : null}
              <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
                {!Array.isArray(allMyUsersPublicConcerts) ? [] : allMyUsersPublicConcerts?.map((pinConcert, index) => 
                  <ConcertPin 
                    key={index} 
                    data={{
                      songsData: songsDataWithPrelude?.filter((x)=> pinConcert?.songs?.some((y)=> y?.songTemplateId === x?._id && y?.status !== "archived")), 
                      concert: pinConcert,
                      user,
                      mindproUsers: mindproUsersProfileData, //mindproUsersProfileData
                      setConcert
                    }} 
                  />)}
              </ScrollDiv>
            </VisDiv>
            <VisDiv rules ={[Array.isArray(assignedToMeConcerts), assignedToMeConcerts?.length > 0]}>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                <h3><T obj={{en: "Concerts Assigned To Me", it: "Concerti Assegnati A Me"}} /></h3>
              </div>
              <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
                {!Array.isArray(assignedToMeConcerts) ? [] : assignedToMeConcerts?.map((pinConcert, index) => 
                  <ConcertPin 
                    key={index} 
                    data={{
                      songsData: songsDataWithPrelude?.filter((x)=> pinConcert?.songs?.some((y)=> y?.songTemplateId === x?._id && y?.status !== "archived")), 
                      concert: pinConcert, 
                      myMindPro: myMindProData,
                      mindproUsers: mindproUsersProfileData, //mindproUsersProfileData 
                      user,
                      setConcert
                    }} 
                  />)}
              </ScrollDiv>
            </VisDiv>
            <VisDiv rules ={[user?.userType !== "user"]}>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                <h3><T obj={{en: "My Concerts", it: "I Miei Concerti"}} /></h3>
              </div>
              {(!Array.isArray(myConcerts) || myConcerts?.length < 1) ? 
                <div className="scroll-item" style={scrollItemStyle}>
                  <p><T obj={{en: "You haven't created any concerts yet", it: "Non hai ancora creato nessun concerto"}} /></p>
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start"}}>
                    <BlueButton color={"green"}hide={user?.userType === "user"} text={<T obj={{en: "Create Concert", it: "Crea Concerto"}} />} fn={createConcert}/>
                  </div>
                  </div> 
                : null}
              <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
                {!Array.isArray(myConcerts) ? [] : myConcerts?.map((pinConcert, index) => 
                  <ConcertPin 
                    key={index} 
                    data={{
                      songsData: songsDataWithPrelude?.filter((x)=> pinConcert?.songs?.some((y)=> y?.songTemplateId === x?._id && y?.status !== "archived")), 
                      concert: pinConcert,
                      user,
                      mindproUsers: mindproUsersProfileData, //mindproUsersProfileData
                      setConcert
                    }} 
                  />)}
              </ScrollDiv>
            </VisDiv>
            <VisDiv rules ={[Array.isArray(mindProConcerts), mindProConcerts?.length > 0]}>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                <h3><T obj={{en: `Concerts created by ${myMindProData?.firstName} ${myMindProData?.lastName}`, it: `Concerti creati da ${myMindProData?.firstName}  ${myMindProData?.lastName}`}} /></h3>
              </div>
              <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
                {!Array.isArray(mindProConcerts) ? [] : mindProConcerts?.map((pinConcert, index) => 
                  <ConcertPin 
                    key={index} 
                    data={{
                      songsData: songsDataWithPrelude?.filter((x)=> pinConcert?.songs?.some((y)=> y?.songTemplateId === x?._id && y?.status !== "archived")), 
                      concert: pinConcert, 
                      myMindPro: myMindProData, 
                      mindproUsers: mindproUsersProfileData, //mindproUsersProfileData
                      user,
                      setConcert
                    }} 
                  />)}
              </ScrollDiv>
            </VisDiv>
            <VisDiv rules ={[Array.isArray(publicConcerts), publicConcerts?.length > 0]}>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                <h3><T obj={{en: "Michael's Concerts", it: "Concerti Di Michael"}} /></h3>
              </div>
              <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
                {!Array.isArray(publicConcerts) ? [] : publicConcerts?.map((pinConcert, index) => 
                  <ConcertPin 
                    key={index} 
                    data={{
                      songsData: songsDataWithPrelude?.filter((x)=> pinConcert?.songs?.some((y)=> y?.songTemplateId === x?._id && y?.status !== "archived")), 
                      concert: pinConcert, 
                      mindproUsers: mindproUsersProfileData, //mindproUsersProfileData
                      setConcert,
                      user
                    }} 
                  />)}
              </ScrollDiv>
            </VisDiv>
            <VisDiv rules ={[Array.isArray(concertsCompleted), concertsCompleted?.length > 0]}>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
                <h3><T obj={{en: "Concerts Completed", it: "Concerti Completati"}} /></h3>
              </div>
              <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
                {!Array.isArray(concertsCompleted) ? [] : concertsCompleted?.map((concertLog, index) => 
                 { 
                const concert = allConcerts?.find(x => x?._id === concertLog?.concertId)
                  return (
                    <ConcertLogPin 
                      key={index} 
                      data={{
                        concertLog, user, concert, 
                        songsData: songsDataWithPrelude?.filter((x)=> concertLog?.songLogs?.some((y)=> y?.songId === x?._id && y?.status !== "archived")), 
                      }} 
                    />)}
                )}
              </ScrollDiv>
            </VisDiv>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "left"}}>
              <h3><T obj={{en: "reMind Songs", it: "Canzoni reMind In Inglese"}} /></h3>
            </div>
            <ScrollDiv style={{display: "flex", flexDirection: "row"}}>
              {!Array.isArray(songsDataWithoutPrelude) ? [] : songsDataWithoutPrelude?.map((song, index) => <SongCard key={index} data={{song}} />)}
            </ScrollDiv>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
              <ConcertMusicPlayer
                  songs={songsDataWithoutPrelude }
                  containerStyle={{  maxWidth: '100%',}}
              />
            </div>


          </div>
        )
    }   

  return (
    <div>
        <div style={{display: "flex", justifyContent: "flex-start"}}>
            <BlueButton hide={hideTestButtons} text={"Test Concert"} fn={testFunction}/>
            <BlueButton color={"green"}hide={false} text={<T obj={{en: "Save Concert", it: "Salva Concerto"}} />} fn={saveConcert}/>
            <BlueButton textColour={blueColour} color={"yellow"}hide={false} text={<T obj={{en: "Reset Concert", it: "Resetta Concerto"}} />} fn={resetConcert}/>
            <BlueButton color={"red"} hide={false} text={<T obj={{en: "Close Concert", it: "Chiudi Concerto"}} />} fn={deleteConcert}/>
        </div>
         <StepByStepProgress progressList={progressList} validationErrors={validationErrors}/>
    </div>
  )
}

export default MakeConcert

export const ConcertPin = ({data={}}) => {
    const {concert={}, setConcert, songsData, mindproUsers, myMindPro, user } = data
    const assignedUser = !Array.isArray(mindproUsers) ? [] : mindproUsers?.find((x) => x?.value === concert?.assignedToUserId)
    //process.env.NODE_ENV === "development" && console.log("assignedUser", {mindproUsers})
    const assignedUserEmail = assignedUser?.label
    const assignedUserName = assignedUser?.firstName
    const assignedUserLastName = assignedUser?.lastName
    const assignedUserDisplayName =assignedUserName && assignedUserLastName ? `${assignedUserName} ${assignedUserLastName}` : assignedUserEmail
    const {title, _id} = concert
    const concertTitles = !Array.isArray(songsData) ? [] : songsData?.map((x) => x?.title)
    const navigateToConcert = () => {
      window.open(`${window.location.origin}/concert?_id=${_id}`, "_self" )
    }
    return (
        <div className="scroll-item" style={{
          display: "flex", 
          width: "370px",
          minWidth: "370px",
          padding: "15px", 
          borderRadius: "10px", 
          border: "1px solid #ccc", 
          margin: "10px",
          flexDirection: "column",
          background: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
            <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
              <VisDiv rules={[concert?.user_id === user?._id]}>
                <FiEdit 
                  style={{cursor: 'pointer', marginRight: '10px'}} 
                  size={20} 
                  onClick={() => setConcert(concert)}
                />
              </VisDiv>
              <IoNavigateCircleOutline 
                style={{marginLeft: "10px", cursor: 'pointer', marginRight: '10px'}} 
                size={27} 
                onClick={navigateToConcert}/>
            </div>
            <div>
              <h3 style={{textAlign: "center", cursor: 'pointer', marginBottom: "10px"}} onClick={navigateToConcert}>{title}</h3>
              <PicturesMash picSrcs={songsData?.map((x) => `https://remind-public.s3.eu-north-1.amazonaws.com/images/${x?.imageName}.png`)}/>
              <VisDiv rules={[concert?.description]}>
                <p>{concert?.description}</p>
              </VisDiv>
              <VisDiv rules={[concert?.aiQuestion]}>
                <h4 style={{textAlign: "center", marginTop: "5px", marginBottom: "5px"}}>How Was I Feeling</h4>
                <p>{concert?.aiQuestion}</p>
              </VisDiv>
              <VisDiv style={{display: "flex", marginTop: "10px", alignItems: "center"}} rules={[assignedUserDisplayName]}>
                <h4 style={{marginRight: "10px"}}><T obj={{en: "Assigned To:", it: "Assegnato A:"}} /></h4>
                <Tag text={assignedUserDisplayName} color={lighterBlueColour} />
              </VisDiv>
              <VisDiv style={{ marginTop: "10px", alignItems: "center"}} rules={[myMindPro?.email]}>
                <h4 style={{marginBottom: "10px"}}><T obj={{en: "Assigned By:", it: "Assegnato Da:"}} /></h4>
                <UserIcon otherUser={myMindPro} size={45} name />
              </VisDiv>
              <GoldTags tagList = {concertTitles}/>
            </div>
        </div>
    )
}
export const SongPin = ({data}) => {

    const {song, concert, setConcert} = data
    const {title, _id} = song

    return (
      <div style={{padding: "3px"}}>
        <p>{title}</p>
      </div>
    )
}
export const PicturesMash = ({picSrcs=[], style={}, picCommonStyle={}}) => {
  return (
    <div style={{
      //position: "relative",
      width: "100%",
      height: "200px",
      background: "white",
      display: "flex",
      ...style
    }}>
      {picSrcs?.map((imageUrl, index) => {
        
        return (
          <div 
            key={index} 
            style={{
              position: "relative",
              flex: 1,
              marginRight: "5px",
              minHeight: "200px",
              overflow: "hidden",
              ...picCommonStyle
            }}
          >
            <img 
              src={imageUrl} 
              style={{
                objectFit: "cover",
                objectPosition: "center" // Ensures the image centers while covering
              }}
              alt={`pic-${index}`}
            />
          </div>
        )
      })}
    </div>
  )
}

const SongCard = ({data={}}) => {
    const {song={}} = data
    const {title, topic, imageName, shortDescription} = song
    const imageUrl = `https://remind-public.s3.eu-north-1.amazonaws.com/images/${imageName}.png`
    const navigateToSong = () => {
      window.open(`${window.location.origin}/song?_id=${song._id}`, "_self")
    }
    const testFunction = () => {
      console.log("testFunction", song, data)
    }
    return (
        <div className="scroll-item" style={{
          display: "flex", 
          width: "300px",
          minWidth: "300px",
          padding: "15px", 
          borderRadius: "10px", 
          border: "1px solid #ccc", 
          margin: "10px",
          flexDirection: "column",
          background: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>

            <BlueButton fn={testFunction} hide={true} text={"Test Song"}/>
{/*             <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
              <IoNavigateCircleOutline 
                style={{marginLeft: "10px", cursor: 'pointer', marginRight: '10px'}} 
                size={27} 
                onClick={navigateToSong}/>
            </div> */}
            <div style={{marginTop: "10px"}}>
              <h3 style={{textAlign: "center", cursor: 'pointer', marginBottom: "10px"}} onClick={navigateToSong}>{title}</h3>
            </div>
            <VisDiv rules={[topic]} style={{marginBottom: "10px", display: "flex", justifyContent: "center"}}>
                <TextHighlight highlight={"amber"}>
                    {topic}
                </TextHighlight>  
            </VisDiv> 
            <div style={{marginBottom: "10px", display: "flex", justifyContent: "center",}}>
              <img src={imageUrl} style={{width: "100%", borderRadius: "10px"}} alt="song-image" />
            </div>
            <VisDiv style={{textAlign: "left", padding: "3px"}} rules={[shortDescription]}>
              <p>{shortDescription}</p>
            </VisDiv>

        </div>
    )
}

export const ConcertLogPin = ({data={}}) => {
    const {concertLog={}, concert={}, songsData=[], user } = data
    const navigate = useNavigate();
    const {journalEntryId} = concertLog
        
    const {title, _id} = concert
    const concertTitles = !Array.isArray(songsData) ? [] : songsData?.map((x) => x?.title)

    const navigateToJournal = () => {
      navigate(`/my-journal/journalEntry?_id=${journalEntryId}`)
    }
    return (
        <div className="scroll-item" style={{
          display: "flex", 
          width: "370px",
          minWidth: "370px",
          padding: "15px", 
          borderRadius: "10px", 
          border: "1px solid #ccc", 
          margin: "10px",
          flexDirection: "column",
          background: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
            <VisDiv rules={[journalEntryId]} style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
              <IoIosJournal 
                style={{marginLeft: "10px", cursor: 'pointer', marginRight: '10px'}} 
                size={27} 
                onClick={navigateToJournal}/>
            </VisDiv>
            <VisDiv rules={[concert?.title]}>
              <h3 style={{textAlign: "center", cursor: 'pointer', marginBottom: "10px"}} onClick={navigateToJournal}>{title}</h3>
              <PicturesMash picSrcs={songsData?.map((x) => `https://remind-public.s3.eu-north-1.amazonaws.com/images/${x?.imageName}.png`)}/>
              <GoldTags tagList = {concertTitles}/>
            </VisDiv>
            <div>
              <ConcertLogReport hideTitle ={true} concertLogData={concertLog} />
            </div>

        </div>
    )
}